import { Col, Row } from "antd";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import LogoGlobalSec from "../../globalsec_logo/container/vodin_logo_container";
   

export interface GraphThingyMainProps{
    version:string,
    onLoadRequested:()=>void;
}
interface GraphThinyViewInnerState{}



  export class FooterView extends Component<GraphThingyMainProps, GraphThinyViewInnerState> 
{

    /**
     * Das laufende Jahr für die Fußzeile.
     *
     * Zuvor stand dort fest "2018-2021" — im September 2026 also seit fünf
     * Jahren falsch, und sichtbar auf jeder Seite. Im Spoke-Frontend ist das
     * bereits so gelöst; hier steht dieselbe Fassung, damit beide Oberflächen
     * dasselbe anzeigen.
     */
    showCurrentYear() {
        return new Date().getFullYear();
    }

    componentDidMount(){
        setTimeout(() => {
         //setInterval(() => {
          // console.log(Date.now());
         this.props.onLoadRequested()
       }, 500);
    }

    render(){
    return (
        <div>
       <Row className="grayheader" gutter={16}>
           <Col span={10}>
               <Row justify="start">
                   <Col>
                   <LogoGlobalSec />
                   </Col>
                   <Col>
                Copyright © 2018-{this.showCurrentYear()} Global-Sec GmbH. <FormattedMessage id="footer:rights" defaultMessage="All rights reserved." />
                </Col>
                </Row>
            </Col>       
            <Col span={8}>
            </Col>
            <Col span={6}>
            <Row justify="end">
                   <Col>
                Anima - Version: {this.props.version}
                </Col>
                </Row>
            </Col>
        </Row>
        </div>
    )
}
}
export default FooterView
